import { useContext } from 'react';
import { useAcquisitionContext } from '~/context/common/AcquisitionContext';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useShouldDisplayOrderStatus from '~/hooks/vdp/selectors/useShouldDisplayOrderStatus';
import useShouldShowPriceDetails from '~/hooks/vdp/selectors/useShouldShowPriceDetails';
import { PricingError } from '~/services/common/contracts/PricingResponse';

export default function useCanShowTerms() {
  const { vehiclePricingError } = useContext(UserVehicleContext);
  const isDealership = useIsDealershipPage();
  const shouldShowPriceDetails = useShouldShowPriceDetails();
  const shouldDisplayOrderStatus = useShouldDisplayOrderStatus();
  const { hasGoogleUTMTerm } = useAcquisitionContext();

  return (
    isDealership ||
    (shouldShowPriceDetails &&
      !shouldDisplayOrderStatus &&
      !hasGoogleUTMTerm &&
      vehiclePricingError === PricingError.None)
  );
}
